import Vue from 'vue';
import Router from 'vue-router';
import NotFound from '@/components/core/core_page/404.vue';
import Home from './views/Home.vue';
import plusView from './views/plusView/microPlusView.vue';
import otpPlusView from './views/otpPlusView/microPlusView.vue';
const originalPush = Router.prototype.push;
Router.prototype.push = function (location) {
    return originalPush.call(this, location).catch(err => err);
};
Vue.use(Router);
export const routeConfig = [
    {
        path: '/secondaryLogon',
        name: 'secondaryLogon',
        meta: { title: '二次验证' },
        component: () => import('./views/secondaryLogon/index.vue')
    },
    {
        path: '/',
        component: Home,
        redirect: '/homePage',
        hidden: false,
        fdId: '1',
        fdFrontLink: '/sn-login',
        name: '常用示例',
        children: [
            {
                path: '/',
                redirect: '/homePage'
            },

            {
                path: '/plusView/*',
                name: 'plusView',
                component: plusView,
                meta: {
                    title: 'SNP plus页面'
                }
            },
            {
                path: '/otpPlusView/*',
                name: 'otpPlusView',
                component: otpPlusView,
                meta: {
                    title: 'SNP otpPlus页面'
                }
            },
            {
                path: '/404',
                name: 'gwms.route.notFound',
                component: NotFound,
                meta: {
                    title: 'notFound'
                }
            }
        ]
    }];
const router = new Router({
    // mode: 'history',
    base: window.__MICRO_APP_BASE_ROUTE__ || process.env.BASE_URL,
    routes: routeConfig
});

export default router;
